import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { MessageSquareQuoteIcon, FlagIcon } from 'lucide-react';
export function TestimonialsSection() {
  return <section id="testimonials" className="py-14 md:py-32 bg-charcoal-dark border-y border-charcoal-light" data-id="element-340" data-mp="20tjkfaian0bg">
      <div className="max-w-4xl mx-auto px-6" data-id="element-341" data-mp="1r1m5bso5zo7g">
        <FadeIn className="text-center mb-10 md:mb-14" data-id="element-342" data-mp="1r0b2bv2jmkhe">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-sand" data-id="element-343" data-mp="1d24e76nebyux">
            Dónde está ELEVATE hoy
          </h2>
        </FadeIn>

        {/* PART 1 — MATÍAS AS PROOF OF CONCEPT */}
        <FadeIn data-id="element-344" data-mp="141g0kd1x00ik">
          <div className="bg-charcoal border-l-4 border-sand p-8 md:p-10 rounded-sm" data-id="element-345" data-mp="141y7q4q47z59">
            <p className="text-xl md:text-2xl font-heading font-bold text-offwhite leading-snug" data-id="element-346" data-mp="1828brbuckfhh">
              El primer resultado de ELEVATE fui yo.
            </p>
            <p className="mt-4 text-lg text-offwhite-dim leading-relaxed" data-id="element-347" data-mp="2ydcx2kf7rwkh">
              Todavía no tengo un salón de testimonios — tengo 10 años de mi
              propia transformación y un método probado en mí mismo antes que en
              nadie más.
            </p>
          </div>
        </FadeIn>

        {/* PART 2 — LORENA'S TESTIMONIAL (PENDING) */}
        <FadeIn delay={0.15} className="mt-4 md:mt-6" data-id="element-348" data-mp="34q2p2vgfnyun">
          <div className="bg-charcoal border border-dashed border-charcoal-light p-8 md:p-10 rounded-sm relative" data-id="element-349" data-mp="2zskoptghery9">
            <MessageSquareQuoteIcon className="absolute top-6 right-6 w-8 h-8 text-sand/20" data-id="element-350" data-mp="2c26vw0q2op2m" />
            <p className="text-sm text-offwhite-dim/50 uppercase tracking-[0.2em] mb-4" data-id="element-351" data-mp="27459b5tfu7me">
              En proceso
            </p>
            <p className="text-base md:text-lg text-offwhite-dim/70 italic leading-relaxed pr-10" data-id="element-352" data-mp="2m1nw42mk2ar7">
              [PENDIENTE: Pedirle a Lorena una frase corta y honesta sobre cómo
              viene el proceso. Máximo 2-3 oraciones. Con su permiso para
              publicarla. Incluir nombre y país.]
            </p>
            <div className="mt-6 flex items-center gap-3" data-id="element-353" data-mp="3sgowqlmizh44">
              <div className="w-10 h-10 bg-charcoal-dark rounded-full border border-charcoal-light flex items-center justify-center shrink-0" data-id="element-354" data-mp="3fk2a8dhp4w9">
                <span className="text-sand font-heading font-bold text-sm" data-id="element-355" data-mp="8fycnx2kcqxg">
                  L
                </span>
              </div>
              <div data-id="element-356" data-mp="ickwqjn2fdyf">
                <span className="text-sm text-offwhite font-medium block" data-id="element-357" data-mp="ib010qp0loyz">
                  Lorena
                </span>
                <span className="text-xs text-offwhite-dim/60 uppercase tracking-wider" data-id="element-358" data-mp="3gv8bmwb5pg10">
                  [PENDIENTE: país]
                </span>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* PART 3 — FOUNDING GROUP FRAMING */}
        <FadeIn delay={0.3} className="mt-4 md:mt-6" data-id="element-359" data-mp="3vitd6lsdv76t">
          <div className="bg-sand/10 border border-sand/30 p-8 md:p-10 rounded-sm" data-id="element-360" data-mp="3vknzo4jaz7d0">
            <div className="flex items-center gap-4 mb-5" data-id="element-361" data-mp="2y2xcndjmi286">
              <div className="bg-charcoal-dark p-3 rounded-sm" data-id="element-362" data-mp="331gy7cub1c00">
                <FlagIcon className="w-6 h-6 text-sand" data-id="element-363" data-mp="1k75rwx9g6rwl" />
              </div>
              <h3 className="text-lg font-heading font-bold text-offwhite uppercase tracking-wider" data-id="element-364" data-mp="1k6cqmbt9culu">
                Primer grupo
              </h3>
            </div>
            <p className="text-lg text-offwhite-dim leading-relaxed" data-id="element-365" data-mp="1b5eojz2dqx5w">
              ELEVATE recién está empezando. Eso significa que si entrás ahora,
              trabajás conmigo directamente — sin equipo, sin intermediarios — y
              en el precio que no se va a repetir una vez que el programa tenga
              historial.{' '}
              <span className="text-sand font-medium" data-id="element-366" data-mp="wfgwv958rpby">
                Sos parte del primer grupo.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}